<template>
  <button class="LogInModalSaveButton" @click="$emit('click', $event)">
    <slot />
  </button>
</template>

<script>
import './style.scss'

export default {
  name: 'LogInModalSaveButton',
  emits: ['click'],
}
</script>
